module.exports = __webpack_public_path__ + "img/logo-company.80fbc6d3.png";